export default {
  shareMeta: {
    title: "Photo by <xx1> on PixelHaha",
    description:
      "Download this free photo created by <xx1> using the AI image generator on PixelHaha.",
  },
  home: {
    picTitle: "Free Stock Images",
    recentSearch: "Recent Searches",
    clear: "Clear",
    trendsSearch: "Trending Searches",
    details: "Details",
    enhance: "EnHance",
    reimagine: "Reimagine",
  },
  search: {
    guess: "You Might Also Like",
    trending: "Trending",
    newest: "Newest",
    empty: "There are no search results yet.",
    goCreate: "Go create the image",
    searchPlaceholder: "Inspiration starts here...",
  },
  detail: {
    share: "share",
    report: "Report",
    downloadFree: "Download",
    prompt: "Prompt",
    more: "You Might Also Like",
    toCreate: "Create",
    enhance: "Photo Enhance",
    invalid:
      "Link unavailable. Creator cancelled publish or image non-compliant.",
    generation: "PixelHaha offers high-quality image generation for you.",
    exploreMore: "Explore More",
    jpg: "JPG",
    png: "PNG",
    download: "Download failed. Please check your network connection and try again.",
  },
  trends: {
    bgTip: "Trending Searches",
    wrong: "Something went wrong",
    retry: "Retry",
    top: "Top",
    a: "A",
    b: "B",
    c: "C",
    d: "D",
    e: "E",
    f: "F",
    g: "G",
    h: "H",
    i: "I",
    j: "J",
    k: "K",
    l: "L",
    m: "M",
    n: "N",
    o: "O",
    p: "P",
    q: "Q",
    r: "R",
    s: "S",
    t: "T",
    u: "U",
    v: "V",
    w: "W",
    x: "X",
    y: "Y",
    z: "Z",
  },
  img: {
    posting: "Pending review",
    audit: "This image has not been reviewed",
    report: "This image contains sensitive content and has been unpublished.",
    deleteQ: "Confirm deletion?",
    cancel: "Cancel",
    delete: "Delete",
  },
  ugcPage: {
    editName: "Edit Name",
    finish: "Finish",
    goHistory: "Go to history publish",
    tabWork: "Work",
    tabFavorites: "Favorites",
    empty: "No data",
    avatarTypeError: "Only.png,.jpg,.webp supported",
  },
  siteMap: {
    page: "Page",
    sort: "Sort",
    keywords: "Keywords",
  },
  report: {
    title: "Report Content",
    text: "Why are you reporting this?",
    reason1: "Violation of Terms of Use",
    reason2: "Low quality",
    reason3: "Spam",
    reason4: "Sensitive content",
    reason5: "Other",
    textplaceholder:
      "Please describe the issues you have found, being as specific as possible.",
    submit: "Confirm Report",
    toastSuccess: "Report submitted successfully. We'll review it soon.",
    toastFailed: "Failed to submit report, please try again.",
  },
};
